import styled from 'styled-components'
import colors from './colors';

const Panel = styled.div<{ hidden?: boolean }>`
  background-color: ${colors.panel};
  border-radius: 20px;
  padding: ${props => props.hidden ? '35px 0px' : '35px'};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: ${props => props.hidden ? '0px' : 'initial'};
  visibility: ${props => props.hidden ? 'hidden' : 'visible'};
  border: 1px solid ${colors.border};
  
  transition: width 0.5s ease-out, visibility 0.5s ease-out, padding 0.5s ease-out;
  
  @media (max-width: 768px) {
    padding: ${props => props.hidden ? '20px 0px' : '20px'};
  }
`

export default Panel
